// dateUtils: 汎用な日付/時間フォーマッタとISO<->input変換

export function fmtDateOnly(isoOrStr: string | Date): string {
  try {
    const d = new Date(isoOrStr as string);
    if (isNaN(d.getTime())) return String(isoOrStr).split(' ')[0];
    return `${d.getMonth() + 1}/${d.getDate()}`;
  } catch (e) {
    return String(isoOrStr);
  }
}

export function fmtTimeOnly(isoOrStr: string | Date): string {
  try {
    const d = new Date(isoOrStr as string);
    if (isNaN(d.getTime())) {
      const m = String(isoOrStr).match(/(\d{1,2}:\d{2})$/);
      return m ? String(m[1]).padStart(5, '0') : String(isoOrStr);
    }
    const hh = String(d.getHours()).padStart(2, '0');
    const mm = String(d.getMinutes()).padStart(2, '0');
    return `${hh}:${mm}`;
  } catch (e) {
    return String(isoOrStr);
  }
}

export function isoToLocalInput(iso: string | Date): string {
  if (!iso) return '';
  try {
    const d = new Date(iso as string);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const hh = String(d.getHours()).padStart(2, '0');
    const mi = String(d.getMinutes()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}T${hh}:${mi}`;
  } catch (e) {
    return '';
  }
}

export function localInputToIso(val: string): string {
  if (!val) return '';
  try {
    const d = new Date(val);
    if (Number.isNaN(d.getTime())) return '';

    const pad = (n: number): string => String(n).padStart(2, '0');
    const year = d.getFullYear();
    const month = pad(d.getMonth() + 1);
    const day = pad(d.getDate());
    const hours = pad(d.getHours());
    const minutes = pad(d.getMinutes());
    const seconds = pad(d.getSeconds());

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}+09:00`;
  } catch (e) {
    return '';
  }
}
